<template>
  <v-row no-gutters>
    <v-col cols="4">
      <div class="my-0 _subtitleFormFont">Tipo:</div>
      <div class="options-container">
        <div 
          v-for="(opt, index) in types" 
          :key="index" 
          :class="['options', {'option-selected': isOptSelected(opt)}]"
          @click="handleChangeType(opt.type)"
        >
          <v-icon size="19" :color="isOptSelected(opt) ? 'bt_color' : ''">
            {{opt.icon}}
          </v-icon>
        </div>
      </div>
    </v-col>

    <v-col cols="4" class="pb-5">
      <FormAlignment v-model="selectedSection.media" keyValue="alignment" label="Alinhamento" />
    </v-col>

    <v-col v-if="selectedSection.media && selectedSection.media.type === 'image'" cols="4" class="pb-5 pl-2">
      <TextField 
        v-model="selectedSection.media.height"
        label="Altura"
        type="number"
        :minValueForNumber="30"
      />
    </v-col>

    <v-col v-if="selectedSection.media.type === 'image'" cols="12">
      <UploadImage v-model="selectedSection.media" keyValue="content"/>
    </v-col>

    <v-col v-if="selectedSection.media.type === 'youtube'" cols="12">
      <TextField 
        v-model="selectedSection.media.videoid"
        label="Código do vídeo (Youtube)"
      />
      <span class="custom-span pt-4">Exemplo do código:</span>
      <span class="custom-span grey--text">
        https://www.youtube.com/watch?v=
        <b style="font-weight: 900" class="darkBlue--text">
          X0iqiir6X4I
        </b>
      </span>
    </v-col>
  </v-row>
</template>

<script>
// Used only for types: cover and menu.
import UploadImage from '../../../_v2/utils/UploadImage.vue'
import TextField from '../../../_v2/ui/TextField.vue'
import FormAlignment from '../../../_v2/utils/FormAlignment.vue'

export default {
  name: 'Media',
  components: { UploadImage, TextField, FormAlignment },
  props: {
    selectedSection: {type: Object, required: true}
  },

  data: () => ({
    types: [
      {type: 'image', icon: 'fa-light fa-image'},
      {type: 'youtube', icon: 'fa-brands fa-youtube'},
    ]
  }),

  methods: {
    isOptSelected (opt) {
      return this.selectedSection.media.type === opt.type
    },

    handleChangeType (type) {
      this.selectedSection.media.type = type
    }    
  }  
}
</script>

<style scoped>
.options-container {
  display: flex;
  gap: 8px
}

.options-container .options {
  display: flex;
  justify-content: center;
  align-items: center;  
  height: 40px !important;
  width: 40px !important;
  border-radius: 8px;
  background-color: #F6F7F7;
  border: 1px solid #EDEDF1; 
  cursor: pointer;
}

.option-selected {
  background-color: #E1F2FEB2 !important;
  border-color: #0067AF80 !important;
}

.custom-span {
  font-size: 0.75rem;
  display: block;
}
</style>